import axios from 'axios'
import URLs from './URLStore'

let packageMedia = {}

var getPacakgeMedia = function(id) {
  if (packageMedia[id]) {
    return new Promise(resolve => {
      resolve(packageMedia[id])
    })
  } else {
    return axios
      .get(URLs.getPackageMedia, {
        params: {
          packageId: id
        }
      })
      .then(resp => {
        packageMedia[id] = resp.data
        return resp.data
      })
  }
}

export default {
  methods: { getPacakgeMedia }
}



// WEBPACK FOOTER //
// ./src/common/preload.js